// Extend with default options and set Cookies as mpro module
mpro.Visitor = {
	_key: null,
	_id: null,
	getKey() {
		if (this._key === null) {
			this._key = mpro.Cookies.get(mpro.config.cookie.visitor);
		}
		return (this._key || '');
	},
	getId() {
		if (this._id === null) {
			this._id = this.getKey().split(':')[0];
		}
		return this._id;
	}
};

export default mpro;
